<template>
  <div id="modalPagamento" class="modal-pagamento" v-if="opened">
    <div class="modal-pagamento-content shadow-sm rounded">
      <div class="py-3 bg-white shadow-sm">
        <div class="container text-center position-relative">
          <a href="javascript:" @click="closeModal" class="btn btn-outline-light position-absolute" style="left: 12px; top: -7px" aria-label="Voltar">
            <i class="fa fa-chevron-left text-dark"></i>
          </a>
          <h1 class="h6 font-weight-bold m-auto">{{ modalTroco ? 'Troco pra quanto?' : 'Pagamentos' }}</h1>
        </div>
      </div>
      <div class="container mt-3 mb-4">
        <div v-if="!modalTroco">
          <div id="pagEntrega" class="row no-gutters" v-if="pagamentos.length">
            <div class="col-6 p-1">
              <a href="javascript:" id="pag5" class="text-dark card card-pagamento shadow-sm"
                 @click="selecionar({})" :class="dados.id_pagamento === '5' ? 'bg-light' : ''">
                <div class="card-body d-flex align-items-center">
                  <div>
                    <h6 class="m-0">Sem pagamento</h6>
                  </div>
                  <div class="text-right" style="margin-left: auto" v-if="dados.id_pagamento === '5'">
                    <i class="fa fa-check text-primary"></i>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-6 p-1" v-for="p in pagamentos">
              <a href="javascript:" :id="'pag' + p.id_pagamento" class="text-dark card card-pagamento shadow-sm"
                 @click="selecionar(p)" :class="dados.id_pagamento === p.id_pagamento ? 'bg-light' : ''">
                <div class="card-body d-flex align-items-center">
                  <div v-if="p.img_pagamento">
                    <img :src="p.img_pagamento" alt="Imagem pagamento" class="mr-2" style="width: 24px">
                  </div>
                  <div>
                    <h6 class="m-0">{{p.nome_pagamento}}</h6>
                    <div v-if="total > 0">
                      <p class="small mb-0" v-if="p.tipo_desconto > 0 && p.valor_taxa !== '0.0'">
                        <span v-if="p.tipo_desconto === '1'">
                          {{ p.valor_taxa * -1 }}% {{ p.minimo_desconto > 0 ? ' off acima de R$ ' + p.minimo_desconto : ' de desconto' }}
                        </span>
                        <span v-if="p.tipo_desconto === '2'">{{ parseFloat(p.valor_taxa) }}% de taxa</span>
                      </p>
                    </div>
                  </div>
                  <div class="text-right" style="margin-left: auto" v-if="dados.id_pagamento === p.id_pagamento">
                    <i class="fa fa-check text-primary"></i>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="card mb-3">
            <div class="card-body d-flex align-items-center">
              <div class="mr-1">
                <img :src="dados.img_pagamento" alt="Imagem pagamento" class="mr-2" style="width: 24px">
              </div>
              <div>
                <h6 class="font-weight-bold mb-0">Dinheiro <a href="javascript:" class="text-primary" @click="modalTroco = false">(alterar)</a></h6>
                <div>
                  Valor do pedido: <b>{{total | valor}}</b>
                </div>
                <div>
                  Valor do troco: <b v-if="dados.troco > total">{{dados.troco - total | valor}}</b><small v-else>(Informe o valor)</small>
                </div>
              </div>
            </div>
          </div>
          <form @submit.prevent="addPagamento">
            <label class="small mb-0 font-weight-bold">Digite o valor que vai pagar em dinheiro</label>
            <money class="form-control" id="trocoPedido" v-model="dados.troco"/>
            <div class="my-2">
              <button class="btn btn-primary btn-block" :disabled="!dados.troco">Salvar</button>
            </div>
            <div>
              <button type="button" class="btn btn-block" @click="semTroco()">
                <span class="text-primary">Não preciso de troco</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Icon from "./IconPdv";
  import Loading from "@/components/gestor/loading";

  export default {
    name: "FormasPagamento",
    components: {Loading, Icon},
    props: ['sacola', 'empresa'],
    data() {
      return {
        opened: false,
        total: 0,
        dados: {
          valor_taxa: 0,
          id_pagamento: '',
          tipo_desconto: '0',
          minimo_desconto: 0,
          img_pagamento: '',
          troco: 0
        },
        modalTroco: false,
        finalizar: false,
        pagamentos: []
      }
    },

    methods: {
      closeModal() {
        document.body.classList.remove("modal-open");
        this.opened = false;
      },

      selecionar(p) {
        this.dados.id_pagamento = p.id_pagamento || '5';
        this.dados.valor_taxa = p.valor_taxa || 0;
        this.dados.minimo_desconto = p.minimo_desconto || 0;
        this.dados.tipo_desconto = p.tipo_desconto || '0';
        this.dados.img_pagamento = p.img_pagamento || null;

        if (p.id_pagamento === '1') {
          this.dados.troco = 0;
          this.$swal({
            text: 'Vai precisar de troco?',
            buttons: ["Não", "Sim"],
            dangerMode: true
          }).then((r) => {
            if (r) {
              this.modalTroco = true;
              this.$nextTick(() => {
                this.$helpers.focusElement('trocoPedido');
              });

            } else {
              this.addPagamento();
            }
          });

        } else {
          this.dados.troco = '';
          this.addPagamento();
        }
      },

      addPagamento() {
        if (this.dados.troco > 0 && this.total > this.dados.troco) {
          this.$swal('Por favor informe o valor que vai pagar em dinheiro. O valor informado deve ser maior que o valor do pedido.').then(() => {
            this.$helpers.focusElement('trocoPedido');
          });

          return;
        }

        this.closeModal();
        this.$emit('addPagamento', this.dados, this.finalizar);
      },

      semTroco() {
        this.dados.troco = 0;
        this.addPagamento();
      },

      abrirPagamento() {
        document.body.classList.add("modal-open");
        this.opened = true;
        this.dados.id_pagamento = this.sacola.id_pagamento;
        this.dados.troco = this.sacola.troco;
        const pagamento = (this.sacola.pagamento || {});
        this.dados.valor_taxa = (pagamento.valor_taxa || 0);
        this.dados.minimo_desconto = (pagamento.minimo_desconto || 0);
        this.dados.tipo_desconto = (pagamento.tipo_desconto || '0');
        this.dados.img_pagamento = (pagamento.img_pagamento || null);
        this.dados.pedido_pago = (pagamento.pedido_pago || '0');
        this.total = this.sacola.total - this.sacola.valor_taxa;
        const pagamentos = this.empresa.pagamentos.filter(p => p.categoria !== '5');

        if (!pagamentos || !pagamentos.length) {
          return;
        }

        this.pagamentos = pagamentos;

        this.$nextTick(() => {
          if (this.modalTroco) {
            this.dados.troco = 0;
            this.$helpers.focusElement('trocoPedido');

          } else {
            this.$helpers.focusElement('pag' + (this.dados.id_pagamento || '5'));
          }
        })
      }
    },

    created() {
      this.$parent.$on('openModalPagamento', (troco, finalizar) => {
        this.modalTroco = !!troco;
        this.finalizar = !!finalizar;
        this.abrirPagamento();
      });

      this.$parent.$on('closeModalPagamento', () => {
        this.closeModal();
      });
    }
  }
</script>

<style scoped>
  .modal-pagamento {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 9040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  .modal-pagamento-content {
    background-color: #fefefe;
    overflow: auto;
    margin: 46px auto;
    width: 500px;
    height: 75vh;
    position: relative;

  }

  .card-pagamento .card-body {
    min-height: 75px;
  }

  .card-pagamento:focus {
    outline: 2px solid var(--primary);
  }

  .card-pagamento:hover {
    text-decoration: none;
  }

  @media (max-width: 600px) {
    .modal-pagamento-content {
      overflow: auto;
      min-height: 100%;
      height: 100vh;
      width: 100%;
      margin: 0;
    }
  }
</style>
